import { __extends } from "tslib";
import { CustomError } from "../../utils/error";
//1.0 - initial version
//2.0 - switched to glTF 2.0 for geometries
//2.1 - fixed roughness of materials by switching env map
export var DOCUMENT_MAJOR_VERSION = 2;
export var DOCUMENT_MINOR_VERSION = 1;
var FileNotFoundError = /** @class */ (function (_super) {
    __extends(FileNotFoundError, _super);
    function FileNotFoundError(pFilename) {
        var _this = _super.call(this, pFilename) || this;
        Object.setPrototypeOf(_this, FileNotFoundError.prototype);
        _this.name = "FileNotFoundError";
        return _this;
    }
    return FileNotFoundError;
}(CustomError));
export { FileNotFoundError };
var AbortError = /** @class */ (function (_super) {
    __extends(AbortError, _super);
    function AbortError(pReason) {
        var _this = _super.call(this, pReason) || this;
        Object.setPrototypeOf(_this, AbortError.prototype);
        _this.name = "AbortError";
        return _this;
    }
    return AbortError;
}(CustomError));
export { AbortError };
